import { useLingui } from '@lingui/react/macro';
import { useIsStaff } from '@web/containers/Timesheets/hooks';

export function useActionBarTitle() {
  const { t } = useLingui();
  const isStaff = useIsStaff();

  return isStaff ? t`Staff timesheet` : t`My timesheet`;
}
